export default "__VITE_ASSET__0ab19d17__"